import React from 'react';
import { getColor, getColorShade } from '../../../src/styled/utils';
import { StyledCounter } from './styled';
import { isNil } from 'ramda';
const DEFAULT_MAX_COUNT = 99;
const DEFAULT_COUNTER_BACKGROUND_COLOR = {
    color: 'danger'
};
const DEFAULT_COUNTER_COLOR = {
    color: 'onDanger'
};
export const getCounterColor = ({ color, shade }) => (shade ? getColorShade(color, shade) : getColor(color));
export const transformCounter = (counter, max) => {
    if (isNil(counter) || counter < 0)
        return '...';
    if (counter > max)
        return `${max}+`;
    return counter;
};
export const Counter = ({ count, backgroundColor = DEFAULT_COUNTER_BACKGROUND_COLOR, maxCount = DEFAULT_MAX_COUNT, textColor = DEFAULT_COUNTER_COLOR, position = { vertical: 'top', horizontal: 'right' }, visible = true, ...rest }) => (React.createElement(StyledCounter, { "$textColor": textColor, "$backgroundColor": backgroundColor, "$position": position, "$visible": visible, ...rest }, transformCounter(count, maxCount)));
